import toolNames from './toolNames';
import { isMobileDevice } from '../../../../util/deviceDetection';
import { isNasiConfigured } from '../../../../util/urlTools';

// eslint-disable-next-line global-require
const getAppConfig = () => require('../../../../store/store').default.getState().config;

const addHistoryTool = (tools) => {
  const patientHistoryDatasource = getAppConfig().DATASOURCE_PATIENT_HISTORY;

  return !isMobileDevice()
    && patientHistoryDatasource?.endpoint
    && patientHistoryDatasource?.template
    && isNasiConfigured()
    ? [...tools, toolNames.HISTORY]
    : tools;
};

const mobileUnavailableTools = new Set([
  toolNames.MODE_3D,
  toolNames.MODE_MPR,
  toolNames.SCREENSHOT,
  toolNames.ANNOTATIONS,
  toolNames.REF_LINES,
  toolNames.HISTORY,
  toolNames.LAYOUT,
  toolNames.GROUPED_TOOLS,
  toolNames.LAYOUT_ECG,
  toolNames.LAYOUT_ECG_GENERAL,
  toolNames.LAYOUT_ECG_12,
  toolNames.LAYOUT_ECG_ALL,
]);

const filterMobileTools = (tools) => tools.filter((toolName) => (
  !mobileUnavailableTools.has(toolName)
));

export const desktopTools2D = [
	toolNames.WWWC,
	toolNames.ZOOM_MENU,
	toolNames.PAN,
	toolNames.ROTATE_MENU,
	toolNames.RESET,
	toolNames.LAYOUT,
	toolNames.MODE_MPR,
	toolNames.MODE_3D,
	toolNames.ANNOTATIONS,
	toolNames.HANGING_PROTOCOLS,
	toolNames.GROUPED_TOOLS,
	toolNames.SCREENSHOT,
	toolNames.LANGUAGE,
];

export const mobileTools2D = [...desktopTools2D];

export const tabletTools2D = [];

export const getDesktopTools2D = () => addHistoryTool(desktopTools2D);

export const getMobileTools2D = () => filterMobileTools(addHistoryTool(mobileTools2D));

export const desktopTools3D = [
	toolNames.WWWC,
	toolNames.ZOOM_MENU,
	toolNames.PAN,
	toolNames.ROTATE,
	toolNames.RESET,
	toolNames.LAYOUT,
	toolNames.ANNOTATIONS,
	toolNames.HANGING_PROTOCOLS,
	toolNames.MODE_2D,
	toolNames.MODE_MPR,
	toolNames.MODE_3D,
	toolNames.CROSS_REFERENCE,
	toolNames.REF_LINES,
	toolNames.CLIPPING,
	toolNames.INTENSITY,
	toolNames.PALETTES_VR,
	toolNames.PALETTES,
	toolNames.SCREENSHOT,
	toolNames.LANGUAGE,
];

export const mobileTools3D = [...desktopTools3D];

export const tabletTools3D = [];

export const getDesktopTools3D = () => addHistoryTool(desktopTools3D);

export const getMobileTools3D = () => filterMobileTools(addHistoryTool(mobileTools3D));

export const desktopToolsECG = [
	toolNames.ANONYMIZE,
	toolNames.LAYOUT_ECG,
	toolNames.DECREASE_SECONDS,
	toolNames.INCREASE_SECONDS,
	toolNames.INCREASE_VOLTAGE,
	toolNames.DECREASE_VOLTAGE,
	toolNames.LAYOUT_ECG_GENERAL,
	toolNames.LAYOUT_ECG_12,
	toolNames.LAYOUT_ECG_ALL,
	toolNames.SCREENSHOT,
	toolNames.LANGUAGE,
];

export const mobileToolsECG = [...desktopToolsECG];

export const tabletToolsECG = [];

export const getDesktopToolsECG = () => addHistoryTool(desktopToolsECG);

export const getMobileToolsECG = () => filterMobileTools(addHistoryTool(mobileToolsECG));

export const groupedTools = [
	toolNames.ANONYMIZE,
	toolNames.REF_LINES,
	toolNames.INVERT,
	toolNames.MAGNIFY_PLUS,
	toolNames.CINE,
	toolNames.WL_PRESETS,
];

export const rotationTools = [
	toolNames.ROTATE,
	toolNames.ROTATE270,
	toolNames.ROTATE90,
	toolNames.HFLIP,
	toolNames.VFLIP,
	toolNames.RESET_POSITION,
];

export const zoomTools = [
	toolNames.ZOOM,
	toolNames.ZOOM_1_TO_1,
	toolNames.ZOOM_FIT,
	toolNames.ZOOM_ACTUAL_SIZE,
];
